module.exports = __webpack_public_path__ + "f54cd9ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/customers/bitmedia.jpg
// module id = 758
// module chunks = 2